import { Menu as Menu$1 } from './Menu.js';
import { MenuItem } from './MenuItem.js';
import { MenuSection } from './MenuSection.js';

var Menu = Menu$1;
Menu.Item = MenuItem;
Menu.Section = MenuSection;
Menu.Item.displayName = 'Menu.Item';
Menu.Section.displayName = 'Menu.Section';

export { Menu };
